import React from "react";
import {AlertBoxProps} from "./alertbox.type";


const AlertBox: React.FC<AlertBoxProps> = ({ text, className, backgroundColor='red-500', textColor='white' }) => {
  return (
    <div
      className={`bg-${backgroundColor} text-${textColor} text-center py-2 rounded mb-4 ${className}`}
    >
      {text}
    </div>
  );
};

export default AlertBox;
